export default __webpack_public_path__ + "static/media/logoinstant-branca1x 2.eb14da8a.svg";